import axios from 'axios';
import Session from "../helpers/session";

const AdminApi = {
    _getConfig: function() {
        const sessionService = new Session();

        let config = {
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        if(sessionService.hasSession()) {
            config.headers['Authorization'] = "Bearer " + sessionService.token;
        }

        config.maxContentLength = 9999999;
        config.responseType = 'json';

        return config;
    },
    _checkAuthorization(errorCallback){
        return function(response){
            if (response.hasOwnProperty("response") && response.response !== undefined && response.response.hasOwnProperty("status") && response.response.status === 401) {
                const sessionService = new Session();
                sessionService.clear();
            }
            errorCallback(response);
        };
    },
    post: function(url, postData, successCallback, errorCallback) {
        axios.post(url, JSON.stringify(postData), this._getConfig())
            .then(successCallback)
            .catch(this._checkAuthorization(errorCallback))
    },
    put: function(url, postData, successCallback, errorCallback) {
        axios.put(url, JSON.stringify(postData), this._getConfig())
            .then(successCallback)
            .catch(this._checkAuthorization(errorCallback))
    },
    delete: function(url, successCallback, errorCallback) {
        axios.delete(url, this._getConfig())
            .then(successCallback)
            .catch(this._checkAuthorization(errorCallback))
    },
    get: function(url, queryData, successCallback, errorCallback) {
        axios.get(url + this.jsonToQueryString(queryData), this._getConfig())
            .then(successCallback)
            .catch(this._checkAuthorization(errorCallback))
    },
    jsonToQueryString: function(json) {
        if (typeof(json) !== "object") return "";
        return '?' +
            Object.keys(json).map(function(key) {
                return encodeURIComponent(key) + '=' +
                    encodeURIComponent(json[key]);
            }).join('&');
    }
};

export default AdminApi;